<template>

    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="48" height="48" viewBox="0 0 48 48">
        <defs>
            <clipPath id="clip-Mail_Light">
                <rect width="48" height="48"/>
            </clipPath>
        </defs>
        <g id="Mail_Light" clip-path="url(#clip-Mail_Light)">
            <g id="Group_39128" data-name="Group 39128" transform="translate(-6889.341 6075)">
                <circle id="Ellipse_1069" data-name="Ellipse 1069" cx="24" cy="24" r="24" transform="translate(6889.341 -6075)" class="svg-primary-color"/>
                <path id="Path_4415" class="svg-on-primary-color" data-name="Path 4415" d="M35-46.122H13a4,4,0,0,0-4,4v14a4,4,0,0,0,4,4H35a4,4,0,0,0,4-4v-14A4,4,0,0,0,35-46.122Zm-25,4a2.979,2.979,0,0,1,.541-1.711l9.224,8.711-9.223,8.71A2.979,2.979,0,0,1,10-28.122Zm3,17a2.978,2.978,0,0,1-1.755-.578l9.248-8.734,2.134,2.015A1.993,1.993,0,0,0,24-31.873a1.993,1.993,0,0,0,1.373-.546l2.134-2.015L36.755-25.7A2.978,2.978,0,0,1,35-25.122Zm25-3a2.975,2.975,0,0,1-.542,1.711l-9.223-8.711,9.224-8.711A2.979,2.979,0,0,1,38-42.122Z" transform="translate(6889.341 -6015.878)"/>
            </g>
        </g>
    </svg>

</template>

<script>
    import {mapGetters} from 'vuex';

    export default {
        name: "emailIcon",
        computed: {
            ...mapGetters({
                getAppPropertyValue: 'TranslationStore/getAppPropertyValue'
            })
        }
    }
</script>



// WEBPACK FOOTER //
// src/common/components/svg/shared/emailIcon.vue